import { Navigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import { ANY_SPORT_PLAY_BOARDS_PRO_BOARD } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams.ts';

const CareerBoardRedirectPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { board } = useTypedParams<PageParams>();

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS_PRO_BOARD, {
        params: { board },
      })}
      replace
    />
  );
};

export default CareerBoardRedirectPage;
